import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';


export interface GrowthbookConfig {
  key: string;
  value: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class RenderGrowthbookConfigsService {

  private readonly subject = new ReplaySubject<GrowthbookConfig[]>(1);

  public get configurations$(): Observable<GrowthbookConfig[]> {
    return this.subject.asObservable();
  }

  public setConfigurations(configs: GrowthbookConfig[]): void {
    this.subject.next(configs);
  }

}
